import field, { Style } from './field';
import type QuestionType from './question';

let Question: typeof import('./question').default;
if (process.env.BROWSER != 'true') {
	Question = require('./question').default;
}

let description: typeof import('./description').default;
let title: (record: QuestionType) => Promise<string>;

if (process.env.BROWSER != 'true' || process.env.TARGET == 'admin') {
	description = require('./description').default;
	title = async (record: QuestionType): Promise<string> => `Select: ${record.title}`;
}


export default {
	field,
	style: Style,
	description,
	title,
	isAnswerable: true,
	question: Question,
	children: ['checklist-item']
}
